import FilterForm from '../../../components/forms/FilterForm';
import { CrudFilters, HttpError } from '@refinedev/core';
import {
  DeleteButton,
  EditButton,
  ShowButton,
  TextField,
  useTable
} from '@refinedev/antd';
import { Form, Input, Space, Table } from 'antd';
import { IEcommerceDivision } from 'interfaces/ecommerce_divisions';
import { ListLayout } from '../../../components/layout/layout/ListLayout';

interface IFilter {
  code: string;
}

export const EcommerceDivisionList = () => {
  const { tableProps, searchFormProps } = useTable<
    IEcommerceDivision,
    HttpError,
    IFilter
  >({
    resource: 'ecommerce/divisions',

    onSearch: params => {
      const filters: CrudFilters = [];
      const { code } = params;

      filters.push({
        field: 'filter[code]',
        operator: 'eq',
        value: code
      });

      return filters;
    }
  });

  return (
    <ListLayout title="Divisões">
      <FilterForm searchFormProps={searchFormProps}>
        <Form.Item name="code">
          <Input placeholder="Código da divisão" className="lg:min-w-[300px]" />
        </Form.Item>
      </FilterForm>

      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="code"
          key="code"
          title="Código"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="description"
          key="description"
          title="Descrição"
          render={value => <TextField value={value} />}
        />
        <Table.Column<IEcommerceDivision>
          title="Ações"
          dataIndex="actions"
          align="center"
          width={100}
          render={(_, record) => {
            return (
              <Space>
                <ShowButton hideText size="small" recordItemId={record.id} />
                <EditButton hideText size="small" recordItemId={record.id} />
                <DeleteButton
                  size="small"
                  resource="ecommerce/divisions"
                  recordItemId={record.id}
                  hideText
                />
              </Space>
            );
          }}
        />
      </Table>
    </ListLayout>
  );
};
